// extracted by mini-css-extract-plugin
export default {"cls1":"VeloActionBar-StyledSeparator_cls1__PAGQj","cls2":"VeloActionBar-StyledSeparator_cls2__o0QYZ VeloActionBar-StyledSeparator_cls1__PAGQj"};